import React from "react";
import { Link } from "react-router-dom";
import SectionLoadingError from '../common/SectionLoadingError';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

class OpenSchedulingError extends React.Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        logUI("MBHWeb.UI.OpenSchedulingError.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { apiMessage, messageIcon, sectionErrorClass, resetStep, phoneNumber } = this.props;
        
        return (
            <div className="row scheduling-error-container">
                <div className="col-12">
                    <SectionLoadingError message={apiMessage ? apiMessage : `We're sorry, the request to schedule an appointment didn't go through. Please call ${phoneNumber} to schedule or try again.`} messageIcon={messageIcon} sectionErrorClass={sectionErrorClass} />       
                </div>
            </div>
        );
    }
}

export default OpenSchedulingError;